import {RepasDTO} from "../dtos/repas-dto";
import {DecoupageRepasDTO} from "../dtos/decoupagerepas-dto";

export class PlanningRowModel{
  repas:RepasDTO;
  composanteRepas:DecoupageRepasDTO;
  nbChoixMax:number;
}
